export const GetRequestList = 'GetRequestList'
export const GetSendRequestList = 'GetSendRequestList'
export const GetApproveRequestList = 'GetApproveRequestList'